import {combine, guard, merge, sample} from 'effector';

import {RestError, showRestError} from 'core/errors';
import {initFiltersTable, initSortingsTable} from 'core/hooks/grid2.0';
import {mapFilters, mapSortings} from 'utils/grid-mappers';

import {
    data$,
    defaultFilters,
    defaultSortings,
    fetchDataFx,
    filters$,
    filtersChanged,
    filtersReset,
    Gate,
    pageNumber$,
    pageSize$,
    sortings$,
    sortingsChanged,
    sortingsReset,
    tableStateChanged,
} from './index';

data$.on(fetchDataFx.done, (state, {result}) => result).reset(Gate.close);
pageNumber$.reset(filtersChanged, sortingsChanged, Gate.close);
pageSize$.reset(Gate.close);

initFiltersTable(filters$, filtersChanged, filtersReset, defaultFilters, Gate.close);
initSortingsTable(sortings$, sortingsChanged, sortingsReset, defaultSortings, Gate.close);

const combinedSource = combine({
    aggregateData: Gate.state,
    sortings: sortings$,
    pageNumber: pageNumber$,
    pageSize: pageSize$,
    filters: filters$,
});

const filteredClock = guard({
    source: combinedSource,
    clock: merge([Gate.state, tableStateChanged]),
    filter: ({aggregateData}) => Boolean(aggregateData?.markingCode),
});

sample({
    source: combinedSource,
    clock: filteredClock,
    fn: ({aggregateData, pageNumber, pageSize, filters, sortings}) => ({
        aggregationNumber: aggregateData.markingCode,
        gtin: aggregateData.gtin,
        paging: {
            pageNumber,
            pageSize,
        },
        filters: mapFilters(filters),
        sortings: mapSortings(sortings),
    }),
    target: fetchDataFx,
});

fetchDataFx.fail.watch(({error}) => showRestError(error as RestError));
